const SEARCHED_FIELDS = ['title', 'pretitle', 'author', 'byLine', 'body'];

// A query re-runs the filter on every keystroke and the body is HTML to
// flatten each time; the records are stable objects, so their text is kept.
const haystacks = new WeakMap();

/**
 * The comparable form of a piece of text: lower case, without diacritics, so
 * "calcio" finds "Cálcio" and the other way round.
 * @param {unknown} value
 * @returns {string}
 */
function searchKey(value) {
    return String(value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, ' ');
}

/**
 * The body as a reader would read it: tags become spaces, so words a tag
 * separates stay separate, and entities read as their character. The
 * template is inert — nothing in the markup runs or loads.
 * @param {unknown} html
 * @returns {string}
 */
function bodyText(html) {
    const template = document.createElement('template');
    template.innerHTML = String(html ?? '').replace(/<[^>]*>/g, ' ');
    return template.content.textContent;
}

function haystack(addOn) {
    let text = haystacks.get(addOn);
    if (text === undefined) {
        text = searchKey(
            SEARCHED_FIELDS.map(field => (field === 'body' ? bodyText(addOn[field]) : addOn[field])).join(' ')
        );
        haystacks.set(addOn, text);
    }
    return text;
}

/**
 * The add-ons a search leaves in the list, in the order they came.
 *
 * @param {Array<object>} addOns - Add-on records
 * @param {string|undefined} query - What the reader typed
 * @returns {Array<object>} The same array for a blank query, otherwise the pieces whose title, pretitle, author, by-line or body text contains it
 */
export function filterAddOns(addOns, query) {
    const needle = searchKey(query).trim();
    if (!needle) return addOns;

    return addOns.filter(addOn => haystack(addOn).includes(needle));
}
